import { JourneyStatus, SalesStatus } from '@audibene/ta.utils-opportunity'
import { OpportunityStatus } from 'constants/opportunityStatus'

export type JourneyAndSalesToLegacyOptions = {
  hasAppointment?: boolean
}

/** Opportunity-like shape: journey/sales status and optional trial end date. */
export type OpportunityLikeInput = {
  journeyStatus?: { status: JourneyStatus } | null
  salesStatus?: { status: SalesStatus } | null
  trialEndDate?: string | null
}

/**
 * Maps new opportunity journey/sales status (and optional hasAppointment) to legacy OpportunityStatus.
 * Used so legacy UI (OpportunityStatusLegacy, search) receives valid legacy enum values.
 */
export function journeyAndSalesToLegacyOpportunityStatus(
  opportunity: OpportunityLikeInput | null | undefined,
  options?: JourneyAndSalesToLegacyOptions
): OpportunityStatus {
  const journey = opportunity?.journeyStatus?.status
  const sales = opportunity?.salesStatus?.status

  if (journey === undefined || journey === null || sales === undefined || sales === null) {
    return OpportunityStatus.UNASSIGNED
  }

  if (journey === JourneyStatus.CLOSED) {
    if (sales === SalesStatus.RETURNED) return OpportunityStatus.HEARING_AIDS_RETURNED
    if (sales === SalesStatus.LOST) return OpportunityStatus.APPOINTMENT_CANCELLED
    if (sales === SalesStatus.WON) return OpportunityStatus.PAYMENT_POSTED
    return OpportunityStatus.UNASSIGNED
  }

  if (journey === JourneyStatus.IN_TRIAL) {
    const trialEndDate = opportunity?.trialEndDate

    if (!trialEndDate) return OpportunityStatus.IN_TRIAL
    const dateToday = new Date()

    dateToday.setHours(0, 0, 0, 0)
    const trialEndLocal = new Date(trialEndDate)

    trialEndLocal.setHours(0, 0, 0, 0)
    return dateToday > trialEndLocal ? OpportunityStatus.TRIAL_COMPLETE : OpportunityStatus.IN_TRIAL
  }

  if (journey === JourneyStatus.OPEN || journey === JourneyStatus.PREPARING_FOR_FITTING_APPOINTMENT) {
    // Phase 2: if options?.hasAppointment === true return APPOINTMENT_SCHEDULED
    if (options?.hasAppointment === true) return OpportunityStatus.APPOINTMENT_SCHEDULED
    return OpportunityStatus.UNASSIGNED
  }

  return OpportunityStatus.UNASSIGNED
}
